module.exports = __webpack_public_path__ + "static/media/YM41_1.b4e89ff2.jpg";